// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2Biyw","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3ecF3"};